import gsap from 'gsap';
import SplitText from "gsap/SplitText";
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

let animDuration = 0.5;

if (!!prefersReducedMotion) {
    animDuration = 0;
}

const $body = $('body'),
    slideInterval = 3000;

const initKeyVisual = function() {
    let $keyVisual = $(this),
        $backgroundSlider = $('.key-visual__background-slider', this),
        $contentSlider = $('.key-visual__content-slider', this),
        $pointer = $('.key-visual__pointer', this);

    if ($backgroundSlider.length > 0) {
        // prep background slider
        let totalSlides = $backgroundSlider.find('.slide').length;

        if ($backgroundSlider.find('.slide--active').length < 1) {
            $backgroundSlider.find('.slide').first().addClass('slide--active');
        }

        let $activeSlide = $backgroundSlider.find('.slide--active');

        if ($activeSlide.length > 0 && totalSlides > 1) {
            let images = $backgroundSlider.find('.slide:not(:first-child) .slide__image');

            if (images.length > 0) {
                gsap.set(images, { opacity: 0 });
            }
        }

        if ($contentSlider) {
            // prep content slider
            let totalSlides = $contentSlider.find('.slide').length;

            if ($contentSlider.find('.slide--active').length < 1) {
                $contentSlider.find('.slide').first().addClass('slide--active');
            }

            let $activeSlide = $contentSlider.find('.slide--active');

            if ($activeSlide.length > 0 && totalSlides > 1) {
                let flipContainers = $contentSlider.find('.slide:not(:first-child) .line-mask .line');

                if (flipContainers.length > 0) {
                    gsap.set(flipContainers, { yPercent: 100 });
                }
            }

            function syncContentSlider(index) {
                if (typeof index !== 'number') return false;

                let activeIndex = index,
                    $prevActiveSlide = $contentSlider.find('.slide--active');

                if (activeIndex === totalSlides) activeIndex = 0;

                $contentSlider.find('.slide').eq(activeIndex).addClass('slide--active').siblings('.slide').removeClass('slide--active');
                $activeSlide = $contentSlider.find('.slide--active');
                animateWordFlips($prevActiveSlide, $activeSlide);
            }

            $backgroundSlider[0].addEventListener('beforeChange', function (e) {
                syncContentSlider(e.detail);
            });
        }

        function nextSlide() {
            $activeSlide = $backgroundSlider.find('.slide--active');

            let activeIndex = $activeSlide.index() + 1,
                $prevActiveSlide = $backgroundSlider.find('.slide--active');

            if (activeIndex === totalSlides) activeIndex = 0;

            let event = new CustomEvent('beforeChange', { 'detail': activeIndex });

            $backgroundSlider[0].dispatchEvent(event);
            $backgroundSlider.find('.slide').eq(activeIndex).addClass('slide--active').siblings('.slide').removeClass('slide--active');
            $activeSlide = $backgroundSlider.find('.slide--active');
            animateBackgrounds($prevActiveSlide, $activeSlide);
        }

        let slideIntervalID = null;

        function startAutoplay() {
            if (slideIntervalID) return;

            slideIntervalID = setInterval(function () {
                nextSlide();
            }, slideInterval);
        }

        function stopAutoplay() {
            if (slideIntervalID) {
                clearInterval(slideIntervalID);
                slideIntervalID = null;
            }
        }

        $body.on('pageLoaderHidden pageTransitionComplete', function () {
            startAutoplay();

            // zoom in first image
            gsap.to($activeSlide.find('.slide__image'), {
                scale: 1.05,
                duration: slideInterval / 1000 + animDuration,
                ease: 'power1.inOut'
            });

            $keyVisual.off('click').on('click', function () {
                nextSlide();
                // reset autoplay timer
                stopAutoplay();
                startAutoplay();
            });
        });
    }

    $keyVisual.on('mousemove', function(e) {
        $pointer.updatePointerPosition(e);
    }).on('mouseleave', function() {
        $pointer.attr('css', '');
    })
}

function animateWordFlips($oldItem, $newItem) {
    if ($oldItem.length > 0) {
        const $oldWords = $oldItem.find('.line');

        if ($oldWords.length) {
            gsap.to($oldWords, {
                duration: animDuration * 2,
                ease: 'power2.inOut',
                yPercent: -100,
                stagger: 0.1,
                opacity: 0
            });
        }
    }

    if ($newItem.length > 0) {
        const $newWords = $newItem.find('.line');

        if ($newWords.length) {
            gsap.fromTo($newWords, {
                    yPercent: 100,
                    opacity: 1
                },
                {
                    duration: animDuration * 2,
                    ease: 'power2.inOut',
                    yPercent: 0,
                    opacity: 1,
                    stagger: 0.1
                }
            );
        }
    }
}

function animateBackgrounds($oldItem, $newItem) {
    if ($oldItem.length && $newItem.length) {
        const $oldImage = $oldItem.find('.slide__image'),
            $newImage = $newItem.find('.slide__image');

        if ($oldImage.length && $newImage.length) {
            let tl = gsap.timeline();

            tl.to($newImage, {
                opacity: 1,
                duration: animDuration * 2,
                ease: 'power2.inOut',
            });

            tl.to($oldImage, {
                opacity: 0,
                scale: 1,
                duration: animDuration * 2,
                ease: 'power2.inOut',
            }, '<');

            tl.fromTo($newImage, {
                scale: 1,
            }, {
                scale: 1.05,
                duration: slideInterval/1000 + animDuration,
                ease: 'power1.out',
            }, '<');
        }
    }
}

$.fn.updatePointerPosition = function(e) {
    const rect = $(this).closest('.key-visual')[0].getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    $(this).css({
        'left' : x + 'px',
        'top' : y + 'px'
    });
}

$body.on('initScripts', function() {
    $('.key-visual').each(initKeyVisual);
});
